<script setup lang="ts">
import {ref, watch} from "vue";
import {useI18n} from 'vue-i18n';
import {useSearchStore} from "@/stores/searchStore";
import {boolean, string} from "yup";
import DestinationPill from "@/components/Destination/DestinationPill.vue";

const props = defineProps({
  'icon':{
    type:boolean,
    default:true
  },
  'class':{
    type:string
  }
})



const model = defineModel<any[]>()
const {t} = useI18n(); // Initialize the i18n function
const searchStore = useSearchStore()
const open = ref(false)
const query = ref('')

function onDestinationClick(value) {
  model.value = [value.value]
  open.value = false
  query.value=value.label
}

watch(query, (newValue) => {
  searchStore.searchDestinations(newValue);
})

watch(model, (newModel) => {

  if(!newModel || newModel.length <=0){return}
  query.value = searchStore.filters.destinations.find((d) => d.value == newModel[0]).label
})

</script>

<template>
  <div class="relative flex">
    <VTextField :placeholder="t('destination')"
                variant="underlined"
                v-model="query"
                :class="props.class"
                @click="open = true">
      <template #prepend-inner>
        <img src="@/assets/icons/svg/Location_16x16.svg" width="16" height="16" :alt="t('destination')"
             v-if="props.icon"
             class="min-w-5"/>
      </template>
    </VTextField>
    <div v-if="open && searchStore.filters.destinations.length > 0" v-click-outside="() => open = false"
         class="px-6 py-4  w-full absolute top-full bg-white shadow-2xl h-fit min-w-[25rem] max-h-[22rem] overflow-y-scroll z-30">
      <div>
        <div v-for="rec in searchStore.filters.destinations" :key="rec.id"
             class="destination-item flex flex-row items-center justify-between gap-2 cursor-pointer"
             @click="onDestinationClick(rec)">
          <div class="line-clamp-1 text-ellipsis">
            <span class="">{{ rec.label }}</span>
          </div>
          <DestinationPill :destination="rec"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.destination-item:not(:last-child) {
  margin-bottom: .75rem;
}
</style>